import { Patient } from "../../../api/patient.types";
import { PatientsBymistokenMainAction } from "./patients.bymistoken.main.types";

export const patientsBymistokenMainRequest = (): PatientsBymistokenMainAction => ({ type: 'PATIENTS_BYMISTOKEN_MAIN_REQUEST' })

export const patientsBymistokenMainSuccess = (users: Patient[]): PatientsBymistokenMainAction => ({ type: 'PATIENTS_BYMISTOKEN_MAIN_SUCCESS', params: { users } })

export const patientsBymistokenMainFailure = () => ({ type: 'PATIENTS_BYMISTOKEN_MAIN_FAILURE' } as const)